import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';

function Login() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [showRegistrationFields, setShowRegistrationFields] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleEmailSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setIsError(false);

    try {
      const response = await fetch(`${API_BASE_URL}/users/mail_check/`, { // Passe die API-Endpunkt-URL an
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setShowPasswordInput(true);
        setMessage('E-Mail gefunden. Bitte gib dein Passwort ein.');
      } else {
        setShowRegistrationFields(true);
        setMessage('E-Mail nicht gefunden. Bitte registriere dich.');
      }
    } catch (error) {
      setIsError(true);
      setMessage('Es gab ein Problem bei der Verbindung zum Server.');
    }
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setIsError(false);

    try {
      const response = await fetch(`${API_BASE_URL}/users/login`, { // Passe die API-Endpunkt-URL an
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Erfolgreiche Anmeldung - Weiterleitung oder Zustandsänderung
        setMessage('Anmeldung erfolgreich!');
        // Hier könntest du den Benutzer weiterleiten, z.B. mit window.location.href = '/dashboard';
      } else {
        setIsError(true);
        setMessage(data.message || 'Falsches Passwort oder Benutzername.');
      }
    } catch (error) {
      setIsError(true);
      setMessage('Es gab ein Problem bei der Verbindung zum Server.');
    }
  };

  const handleRegistrationSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setIsError(false);

    try {
      const response = await fetch(`${API_BASE_URL}/users/register`, { // Passe die API-Endpunkt-URL an
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password, username }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Registrierung erfolgreich! Du kannst dich jetzt anmelden.');
        setShowRegistrationFields(false);
        setShowPasswordInput(true);
      } else {
        setIsError(true);
        setMessage(data.message || 'Fehler bei der Registrierung.');
      }
    } catch (error) {
      setIsError(true);
      setMessage('Es gab ein Problem bei der Verbindung zum Server.');
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Row className="w-100">
        <Col md={6} className="mx-auto">
          <Card className="p-4 shadow">
            <Card.Body>
              <h2 className="text-center mb-4">{showRegistrationFields ? 'Registrieren' : 'Login'}</h2>

              {!showPasswordInput && !showRegistrationFields && (
                <Form onSubmit={handleEmailSubmit}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>E-Mail-Adresse</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Gib deine E-Mail-Adresse ein"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Weiter
                  </Button>
                </Form>
              )}

              {showPasswordInput && !showRegistrationFields && (
                <Form onSubmit={handlePasswordSubmit}>
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Passwort</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Passwort"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Anmelden
                  </Button>
                </Form>
              )}

              {showRegistrationFields && (
                <Form onSubmit={handleRegistrationSubmit}>
                  <Form.Group className="mb-3" controlId="formBasicEmailRegister">
                    <Form.Label>E-Mail-Adresse</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Gib deine E-Mail-Adresse ein"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicUsernameRegister">
                    <Form.Label>Benutzername</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Wähle einen Benutzernamen"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicPasswordRegister">
                    <Form.Label>Passwort</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Passwort"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Button variant="success" type="submit" className="w-100">
                    Registrieren
                  </Button>
                </Form>
              )}

              {message && (
                <Alert variant={isError ? 'danger' : 'success'} className="mt-3">
                  {message}
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;